const INITIAL_STATE = {
  data: null,
  error: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FEATURE_PROMOTION_SUCCESS":
      return { ...state, data: action.payload };

    case "FEATURE_PROMOTION_FAIL":
      return { ...state, error: action.payload };

    default:
      return state;
  }
};
